function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
export const SESSION_KEY = "vp_session";
export const CLIENT_KEY = "client";

let isRedirecting = false;

// In-memory snapshots of protected keys to detect external tampering
const _snapshots = {};

const logoutDueToTamper = () => {
  if (isRedirecting) return;
  isRedirecting = true;
  try { localStorage.clear(); } catch (e) { }
  alert("Session data has been modified. You have been logged out for security.");
  window.location.href = "/login";
};

export const redirectToLoginIfSessionMissing = () => {
  if (isRedirecting) return;
  if (typeof localStorage !== "undefined" && typeof window !== "undefined") {
    const pathname = window.location.pathname;
    const isProtectedRoute = pathname.startsWith("/app");
    const isPublicAuthRoute =
      pathname === "/login" ||
      pathname.startsWith("/login") ||
      pathname === "/signup" ||
      pathname.startsWith("/signup") ||
      pathname === "/forgot-password" ||
      pathname === "/create-new";

    const hasSession = !!localStorage.getItem(SESSION_KEY);
    const hasClient = !!localStorage.getItem(CLIENT_KEY);

    if (isProtectedRoute && (!hasSession || !hasClient)) {
      isRedirecting = true;
      try {
        localStorage.clear();
      } catch (e) { }
      if (!isPublicAuthRoute) {
        window.location.href = "/login";
      }
    }
  }
};

export const checkSessionExpiry = () => {
  if (typeof localStorage !== "undefined") {
    const setupTime = localStorage.getItem("setupTime");
    const now = new Date().getTime();
    if (setupTime && now - setupTime > 10 * 60 * 60 * 1000) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
  }
  redirectToLoginIfSessionMissing();
};

const LocalStorage = {
  getItem(key) {
    if (typeof localStorage !== "undefined") {
      const value = localStorage.getItem(key);
      if (value !== "" && value !== undefined && value !== null) {
        if (IsJsonString(value)) {
          return JSON.parse(value);
        }
        return value;
      }
    }
    return null;
  },
  has(key) {
    return !!LocalStorage.getItem(key);
  },
  setItem(key, value) {
    if (typeof localStorage !== "undefined") {
      const item = typeof value === "string" ? value : JSON.stringify(value);
      localStorage.setItem(key, item);
      if (key === SESSION_KEY || key === CLIENT_KEY) {
        _snapshots[key] = item;
      }
    }
  },
  removeItem(key) {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem(key);
      if (key === SESSION_KEY || key === CLIENT_KEY) {
        redirectToLoginIfSessionMissing();
      }
    }
  },
  clear() {
    if (typeof localStorage !== "undefined") {
      localStorage.clear();
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/app")) {
        window.location.href = "/login";
      }
    }
  },
  updateObject(key, change) {
    if (typeof localStorage !== "undefined" && typeof change != "undefined") {
      const data = LocalStorage.getItem(key);
      const update = change(Object.assign({}, data));
      if (typeof update != "undefined" && update) {
        LocalStorage.setItem(key, update);
      }
    }
  },
};

if (typeof window !== "undefined") {
  try {
    if (window.localStorage) {
      const originalRemoveItem = window.localStorage.removeItem.bind(window.localStorage);
      window.localStorage.removeItem = function (key) {
        originalRemoveItem(key);
        if (key === SESSION_KEY || key === CLIENT_KEY) {
          redirectToLoginIfSessionMissing();
        }
      };

      const originalClear = window.localStorage.clear.bind(window.localStorage);
      window.localStorage.clear = function () {
        originalClear();
        redirectToLoginIfSessionMissing();
      };
    }
  } catch (e) { }

  [SESSION_KEY, CLIENT_KEY].forEach((key) => {
    const val = localStorage.getItem(key);
    if (val !== null) _snapshots[key] = val;
  });

  window.addEventListener("storage", (e) => {
    if (e.key === SESSION_KEY || e.key === CLIENT_KEY || e.key === null) {
      redirectToLoginIfSessionMissing();
    }
  });

  window.addEventListener("focus", () => {
    redirectToLoginIfSessionMissing();
  });

  setInterval(() => {
    redirectToLoginIfSessionMissing();
    // Detect external tampering of protected keys
    [SESSION_KEY, CLIENT_KEY].forEach((key) => {
      if (key in _snapshots) {
        const current = localStorage.getItem(key);
        if (current !== _snapshots[key]) {
          logoutDueToTamper();
        }
      }
    });
  }, 500);
}

export default LocalStorage;
